{
    "help": {
        "button": { "tooltip": "AI-hjälpare", "label": "Fråga Frøy" },
        "title": "Fråga Frøy",
        "reconnecting": "Återansluter…",
        "thinking": "Tänker…",
        "noMessagesYet": "Hej! Jag är Frøy, din assistent för Vince Platform. \nFråga mig vad som helst om hur Vince Platform fungerar: funktioner, arbetsflöden eller var du hittar det du behöver, så hjälper jag dig att hitta rätt svar och dokumentation.",
        "typeYourMessage": "Skriv ditt meddelande…",
        "collapse": "Stäng",
        "displayMode": {
            "dock": "Fäst som sidopanel",
            "float": "Visa över innehållet"
        },
        "choice": { "placeholder": "Välj ett alternativ", "confirm": "Bekräfta" },
        "reader": {
            "back": "Tillbaka",
            "fullscreen": "Helskärm",
            "exitFullscreen": "Avsluta helskärm",
            "close": "Stäng",
            "openInApp": "Öppna i appen",
            "loading": "Laddar…",
            "error": "Det gick inte att ladda detta dokument.",
            "retry": "Försök igen"
        },
        "context": {
            "title": "Justera svar",
            "optionsError": "Det gick inte att ladda avdelningsalternativ.",
            "industry": "Bransch",
            "department": "Team",
            "notSet": "Ej angivet",
            "answers": "Svar",
            "thisConversation": "Denna konversation",
            "aboutYou": "Om dig",
            "aboutYouHint": "Ställs in en gång. Används för att välja exempel och begrepp.",
            "level": "Din kunskapsnivå",
            "length": "Svarslängd",
            "done": "Tillämpa",
            "appliesNext": "Gäller från din nästa fråga",
            "familiarityQuestion": "Hur bekant är du med Vince-plattformen?",
            "familiarityHint": "Justerar hur mycket detalj AI:n ger.",
            "lengthQuestion": "Hur långa ska svaren vara?",
            "lengthHint": "Välj korta eller fullständigt förklarade svar.",
            "fullRestricted": "Fullständiga svar är inte tillgängliga för ditt konto ännu.",
            "departmentQuestion": "Vilken avdelning tillhör du?",
            "departmentHint": "Hjälper till att anpassa exempel och länkar till ditt team.",
            "industryQuestion": "Vilken bransch tillhör du?",
            "industryHint": "Anges av din organisation."
        },
        "notice": {
            "busy": "Hjälpen är upptagen. Försöker igen…",
            "paused": "Chatten är pausad. Tryck för att återuppta.",
            "badFrame": "Anslutningsfel. Återansluter…",
            "connectFailed": "Det gick inte att starta Hjälp. Försök igen.",
            "resume": "Återuppta",
            "retry": "Försök igen",
            "turnInterrupted": "Ditt senaste meddelande kom kanske inte fram – skicka det igen."
        },
        "level": {
            "beginner": "Nybörjare",
            "beginnerHint": "Förutsätter ingen erfarenhet av VinceLive",
            "beginnerRadioLabel": "Precis börjat",
            "beginnerRadioHint": "Steg-för-steg-förklaringar.",
            "intermediate": "Medel",
            "intermediateHint": "Hoppar över grunderna",
            "intermediateRadioLabel": "Viss erfarenhet",
            "intermediateRadioHint": "Snabba svar, mer detaljer om du frågar.",
            "advanced": "Avancerad",
            "advancedHint": "Direkt till inställningen",
            "advancedRadioLabel": "Ganska säker",
            "advancedRadioHint": "Hoppar över grunderna, men flaggar det som är nytt.",
            "expert": "Expert",
            "expertHint": "Kortfattat, ingen genomgång",
            "expertRadioLabel": "Använder detta hela tiden",
            "expertRadioHint": "Bara det viktigaste, ingen genomgång."
        },
        "length": {
            "brief": "Kort",
            "full": "Fullständig"
        },
        "send": "Skicka",
        "setup": {
            "title": "Ställ in din AI-hjälpare",
            "hint": "Berätta din erfarenhetsnivå och avdelning så anpassas svaren från start.",
            "skip": "Inte nu",
            "save": "Spara"
        }
    },
    "support": {
        "title": "Mina supportärenden",
        "refresh": "Uppdatera",
        "loading": "Laddar dina ärenden…",
        "empty": "Du har inte rapporterat några problem ännu — be hjälpassistenten att rapportera ett.",
        "error": "Supportärenden är tillfälligt otillgängliga.",
        "reportedOn": "Rapporterat {date}",
        "status": {
            "new": "Ny",
            "waitingOnContact": "Väntar på kontakt",
            "waitingOnUs": "Väntar på oss",
            "closed": "Stängd",
            "unknown": "Okänd"
        }
    },
    "ai": {
        "usage": {
            "emptyState": "Ingen användning har registrerats ännu.",
            "totalTokens": "Totala tokens",
            "estimatedCost": "Uppskattad kostnad",
            "sessions": "Sessioner",
            "inputTokens": "In-tokens",
            "outputTokens": "Ut-tokens",
            "cacheCreationTokens": "Tokens för cache-skrivning",
            "cacheReadTokens": "Tokens för cache-läsning",
            "tokenBreakdown": "Tokenfördelning",
            "fundingBreakdown": "Kostnadsfördelning",
            "yourConnection": "Din anslutning",
            "estimateDisclaimer": "Token-antal är exakta. Dollarbelopp är uppskattningar och kan skilja sig från faktisk fakturering.",
            "vinceAi": "Vince AI",
            "estimateHint": "Löpande total för den här byggsessionen. Dollarbeloppet är en uppskattning.",
            "tokensValue": "{value} tokens",
            "estimateSuffix": "(uppsk.)",
            "noUsageRecorded": "Ingen användning har registrerats för den här sessionen.",
            "vinceProvided": "Tillhandahålls av Vince",
            "unknownConnection": "Okänd anslutning",
            "byConnection": "Efter anslutning",
            "sessionsCount": "{count} sessioner",
            "unpricedUsage": "Viss användning kunde inte prissättas",
            "permissionDenied": "Du har inte behörighet att visa den här användningen.",
            "loadError": "Användningen kunde inte läsas in. Försök igen.",
            "exactHint": "Löpande total för den här byggsessionen. Dollarbeloppet är exakt.",
            "cost": "Kostnad",
            "billedCost": "Fakturerad kostnad",
            "legacyEstimate": "Uppskattad total inklusive tidigare användning: {value}",
            "billedExcludesHistory": "Exkluderar tidigare användning som registrerats före exakt prissättning.",
            "exactDisclaimer": "Token-antal och dollarbelopp är exakta enligt fakturering."
        },
        "costOverview": {
            "title": "Kostnadsöversikt",
            "accumulatedCost": "Ackumulerad kostnad",
            "summary": "Kostnadssammanfattning",
            "cost": "Kostnad",
            "billedCost": "Fakturerad kostnad",
            "estimatedTotal": "Uppskattad totalsumma",
            "sessions": "Sessioner",
            "calls": "API-anrop",
            "tokens": "Tokens",
            "aiModel": "AI-modell",
            "aiModels": "AI-modeller",
            "costByConnection": "Fakturerad kostnad per anslutning",
            "allConnections": "Alla anslutningar",
            "showAll": "Visa alla",
            "selectConnection": "Visa kostnader för {name}",
            "historicalEstimateNote": "Fakturerad kostnad utesluter tidigare användning som registrerades före exakt prissättning. Den uppskattade totalsumman inkluderar denna tidigare användning.",
            "unknownConnection": "Okänd",
            "total": "Totalt",
            "noCostData": "Ingen kostnadsdata är tillgänglig.",
            "loadError": "Kostnadsdata kunde inte läsas in.",
            "description": "Sök i hela användningshistoriken och förfina sedan resultatet efter system eller modell.",
            "searchFilters": "Sökfilter för användning",
            "connection": "Anslutning",
            "user": "Användare",
            "users": "Användare",
            "allUsers": "Alla användare",
            "label": "Etikett",
            "allLabels": "Alla etiketter",
            "range": "Period",
            "granularity": "Detaljnivå",
            "lifetime": "Hela perioden",
            "last7Days": "Senaste 7 dagarna",
            "last30Days": "Senaste 30 dagarna",
            "last90Days": "Senaste 90 dagarna",
            "customRange": "Anpassad…",
            "daily": "Dagligen",
            "weekly": "Veckovis",
            "from": "Från",
            "to": "Till",
            "completeDateRange": "Välj både start- och slutdatum.",
            "invalidDateRange": "Startdatumet måste vara före eller samma som slutdatumet.",
            "vinceAi": "Vince AI",
            "refineResults": "Förfina returnerad användning",
            "system": "System",
            "model": "Modell",
            "availableWithData": "Tillgänglig med data",
            "allSystems": "Alla system",
            "allModels": "Alla modeller",
            "systemsSelected": "{count} system",
            "modelsSelected": "{count} modeller",
            "retry": "Försök igen",
            "loading": "Laddar",
            "noUsageInPeriod": "Ingen användning registrerades under perioden.",
            "noUsage": "Ingen användning har registrerats ännu.",
            "unpricedUsage": "Viss användning saknar pris, så ingen totalsumma visas.",
            "totalTokens": "Totalt antal tokens",
            "sessionsUnavailable": "Sessioner är inte tillgängliga för denna förfining",
            "sessionCount": "{count} sessioner",
            "callCount": "{count} anrop",
            "dailyUsage": "Daglig användning",
            "weeklyUsage": "Veckovis användning",
            "dailyCost": "Daglig kostnad",
            "weeklyCost": "Veckovis kostnad",
            "chartValue": "Diagramvärde",
            "splitBy": "Dela upp efter",
            "viewAs": "Visa som",
            "chart": "Diagram",
            "table": "Tabell",
            "noSeriesData": "Ingen tidsseriedata är tillgänglig för denna användning.",
            "date": "Datum",
            "unpricedChartNote": "Punkter med användning utan pris exkluderar de saknade kostnaderna.",
            "inputTokens": "Input-tokens",
            "outputTokens": "Output-tokens",
            "cacheWriteTokens": "Cache write-tokens",
            "cacheReadTokens": "Cache read-tokens",
            "tokenBreakdown": "Tokenfördelning",
            "unknownSystem": "Okänt system"
        }
    },
    "foundation": {
        "resource": {
            "apiclient": "API-klient",
            "connection": "Anslutning",
            "dashboard": "Instrumentpanel",
            "environment": "Miljö",
            "user": "Användare",
            "workflow": "Arbetsflöde",
            "group": "Grupp",
            "variable": "Variabel",
            "webhook": "Webhook",
            "metadata": "Metadata",
            "role": "Roll",
            "gateway": "Gateway"
        }
    },
    "core": {
        "app": {
            "ai-apps": "AI-appar",
            "customtables": "Anpassade tabeller",
            "fnd": "Grund",
            "tenantManagement": "Hyresgästhantering"
        }
    },
    "addon": {
        "app": {
            "kanban": "Kanban",
            "campaign": "Kampanj",
            "impexHelper": "Impex-hjälpare",
            "mdbreadmiHelper": "MDB Readmi-hjälpare",
            "miTest": "MI-test",
            "m3PrintoutConfig": "M3-utskriftskonfiguration",
            "vincePricer": "Vince Pricer",
            "cugexHelper": "CUGEX-hjälpare",
            "isLantmannen": "Är Lantmännen",
            "spykar": "Spykar",
            "eshopbox": "Eshopbox",
            "scannerPickPack": "Skanner Pick Pack",
            "pickPack": "Pick Pack",
            "contractManagement": "Kontrakthantering",
            "aiApps": "AI-appar",
            "aiWorkflows": "AI-arbetsflöden"
        },
        "resource": {
            "aiWorkflow": "Arbetsflöde"
        }
    },
    "fileSelector": {
        "microsoftThrottled": "Microsoft har tillfälligt begränsat SharePoint-förfrågningar. Vänta en stund och försök igen.",
        "sitesLoadFailed": "Det gick inte att läsa in SharePoint-webbplatser.",
        "itemsLoadFailed": "Det gick inte att läsa in SharePoint-filer.",
        "fileError": "Filen är för stor för att förhandsgranska eller ladda upp. Välj en mindre fil.",
        "retry": "Försök igen"
    },
    "wildcard": {
        "option": "Alla",
        "fullAccess": "Full åtkomst"
    },
    "action": {
        "read": "Läsa",
        "write": "Skriva"
    },
    "customTable": {
        "resource": {
            "configuration": "Konfiguration",
            "data": "Data"
        }
    },
    "common": {
        "logicalOperators": {
            "AND": "OCH",
            "OR": "ELLER"
        },
        "actions": {
            "advanced": "Avancerade inställningar",
            "apply": "Använd",
            "back": "Tillbaka",
            "cancel": "Avbryt",
            "clear": "Rensa",
            "close": "Stäng",
            "copy": "Kopiera",
            "create": "Skapa",
            "delete": "Ta bort",
            "yesDelete": "Ja, ta bort",
            "edit": "Redigera",
            "next": "Nästa",
            "no": "Nej",
            "ok": "Ok",
            "previous": "Föregående",
            "reset": "Återställ",
            "save": "Spara",
            "update": "Uppdatera",
            "view": "Visa",
            "yes": "Ja",
            "activate": "Aktivera",
            "deactivate": "Inaktivera",
            "goHomePage": "Gå tillbaka till startsidan",
            "add": "Tillägga",
            "execute": "Utföra",
			"selectAll": "Välj alla",
			"showSelected": "Visa valda"
        },
        "system": "System",
        "label": "Etikett",
        "labels": "Etiketter",
        "actionsLabel": "Åtgärder",
        "noPermission": "Ingen behörighet",
        "active": "Aktiv",
        "activated": "Aktiverad",
        "deactivated": "Inaktiverad",
        "address": "Adress",
        "alias": "Alias",
        "confirmation": "Bekräftelse",
        "description": "Beskrivning",
        "details": "Detaljer",
        "download": "Ladda ner",
        "email": "E-post",
        "tenantPermissions": "Klientbehörigheter",
        "firstName": "Förnamn",
        "fullName": "Fullständigt namn",
        "surname": "Efternamn",
        "in": "i",
        "lastName": "Efternamn",
        "left": "Vänster",
        "loading": "Belastning",
        "milliseconds": "ms.",
        "name": "Namn",
        "notFound": "Hittades inte",
        "notFoundAbbreviation": "HI",
        "of": "av",
        "operation": {
            "EqualTo": "Lika med",
            "GreaterThan": "Större än",
            "GreaterThanEqualTo": "Större än eller lika med",
            "LessThan": "Mindre än",
            "LessThanEqualTo": "Mindre än eller lika med",
            "NotEqualTo": "Inte lika med"
        },
        "password": "Lösenord",
        "permissions": "Behörigheter",
        "phone": "Telefon",
        "primary": "PRIMÄR",
        "right": "Rätt",
        "roles": "Roller",
        "noRoles": "Inga roller tilldelade",
        "search": "Söka",
        "searchPlaceholder": "Skriv för att söka",
        "texts": {
            "item": "punkt",
            "selected": "vald",
            "select": "Velge"
        },
        "tags": "Taggar"
    },
    "comparison": {
        "equal": "Lika med (=)",
        "greaterThan": "Större än (>)",
        "greaterThanInclusive": "Större än eller lika med (>=)",
        "isBlank": "Är tom (=)",
        "isNotBlank": "Är inte tom (!=)",
        "lessThan": "Mindre än (<)",
        "lessThanInclusive": "Mindre än eller lika med (<=)",
        "notEqual": "Inte lika med (!=)",
        "stringContains": "Sträng innehåller",
        "stringNotContains": "Sträng innehåller inte"
    },
    "dataTypes": {
        "DATE": "Datum",
        "NUMERIC": "Nummer",
        "STRING": "Text",
        "BOOLEAN": "Boolesk"
    },
    "environments": {
        "code": "Miljö-ID i VXL Live",
        "deleteConfirmation": "Vill du ta bort {environmentName}?",
        "descriptionRequired": "Miljöbeskrivning krävs",
        "environmentActions": {
            "deleteEnvironment": {
                "title": "Bekräfta borttagning"
            }
        },
        "idRequired": "Miljö-ID krävs",
        "messages": {
            "deleteSuccess": "Miljön har tagits bort!",
            "cannotDeleteEnvironmentInConnection": "Kan inte tas bort, miljön finns i en anslutning",
            "codeFormat": "Koden accepterar 1-4 bokstäver (A-Ö). Exempel: TEST, PROD",
            "environmentNameExists": "Miljön {environmentName} finns redan!",
            "errorOccurred": "Ett fel inträffade",
            "success": "Miljön sparades framgångsrikt!"
        },
        "nameRequired": "Miljönamn krävs",
        "newEnvironment": "Ny Miljö",
        "selectColor": "Välj en färg",
        "theme": "Tema",
        "title": "Miljöer"
    },
    "header": {
        "apiClients": "API-klienter",
        "roles": "Roller",
        "users": "Användare",
        "tenants": "Hyresgäster"
    },
    "connections": {
        "port": "Hamn",
		"m3Name": "M3 namn",
		"clientId": "Klient-ID",
		"clientSecret": "Klienthemlighet",
		"autofillDetails": "Autofyll från fil",
		"uploadFile": "Ladda upp fil",
        "authenticationType": "Autentiseringstyp",
        "accessKey": "Åtkomstnyckel",
        "authHeaderName": "Namn på autentiseringsheader",
		"messages": {
			"confirmDeleteHeader": "Ta bort anslutning",
			"confirmDeleteMessage": "Är du säker på att du vill ta bort den här anslutningen?",
			"confirmCertificateIssueHeader": "Utfärda certifikat",
			"confirmCertificateIssueMessage": "Är du säker på att du vill utfärda certifikat för den här anslutningen?",
			"confirmCertificateRevokeHeader": "Återkalla certifikat",
			"confirmCertificateRevokeMessage": "Är du säker på att du vill återkalla certifikatet för den här anslutningen?",
			"saveSuccess": "Anslutningen har sparats",
			"deleteSuccess": "Anslutningen raderades",
			"validateSuccess": "Anslutningen har validerats",
			"certificateIssueSuccess": "Certifikat utfärdat framgångsrikt",
            "certificateRevokeSuccess": "Certifikatet har återkallats.",
            "mandatoryField": "Detta fält är obligatoriskt",
            "cannotDelete": "Den här anslutningen kan inte tas bort eftersom den är länkad till ett eller flera arbetsflöden",
            "importApiErrorMessage": "Det gick inte att importera API:er.",
            "bulkImportApiError": "Det gick inte att starta massimport av API:er.",
            "loadApiProgramsError": "Det gick inte att läsa in API-program för den här anslutningen.",
            "loadConnectionForImportError": "Det gick inte att läsa in den valda anslutningen.",
            "errorWithReason": "{message} Orsak: {reason}",
            "environmentAlreadyConnectedError": "En anslutning av typen {system} finns redan i {environment}-miljön!",
            "certificateIgnoredMessage": "Om 'Använd proxy' är aktiverat kommer certifikatet att ignoreras.",
            "certificate": "Certifikat"
        },
        "certificate": {
			"title": "MTLS-certifikat",
			"VinceLiveCertificate": "Använd Vince Live-certifikat",
			"CustomCertificate": "Använd anpassat certifikat",
			"label": "Certifikat",
			"privateKey": "Privat nyckel",
			"VLCertificatePlaceholder": "Certifikat från Vince Live",
			"CustomCertificatePlaceholder": "Ange certifikat eller ladda upp fil nedan",
			"CustomPrivateKeyPlaceholder": "Ange privat nyckel eller ladda upp fil nedan",
			"fileWarningMessage": "Filen måste vara i OpenSSL-format",
			"changePrivateKey": "Ändra privat nyckelfil",
			"changeCertificate": "Ändra certifikatfil",
			"privateKeyLoaded": "✓ Privat nyckel laddad ({length} tecken)",
			"certificateLoaded": "✓ Certifikat laddat ({length} tecken)"
		},
        "connectivity": "Anslutning",
        "security": "Säkerhet",
        "details": "Detaljer"
	},
    "notifications": {
		"noNotifications": "Inga nya aviseringar",
		"announcement": "Kungörelse",
		"title": "Varsler",
        "clearAll": "Rensa alla",
        "workflowSuccessful": "Arbetsflöde körning lyckades",
        "workflowFailed": "Arbetsflöde misslyckades",
		"acknowledge": "Bekräfta avisering",
		"customTables": {
			"header": "Tabellindexeringsfel",
			"indexError": "Indexering misslyckades för tabell \"{tableName}\"",
			"toastSummary": "Tabellindexeringsfel",
			"toastDetailWithReason": "Tabell: \"{tableName}\"\nNycklar: {keys}\n\nOrsak: {reason}",
			"toastDetail": "Tabell: \"{tableName}\"\nNycklar: {keys}\n\nIndexering misslyckades",
			"viewTable": "Visa tabell",
			"unknownError": "Okänt fel"
		}
	},
    "home": {
        "greeting": {
            "morning": "God morgon",
            "afternoon": "God eftermiddag",
            "evening": "God kväll"
        },
        "tenantLabel": "Hyresgäst:",
        "welcomeMessage": "Välkommen till Vince-plattformen.\nSkapa, automatisera och hantera ditt arbete på ett ställe — från att bygga appar och arbetsflöden till att strukturera data i tabeller och hantera administration med säkerhet. Love from Vince Team 🧡\nOm du saknar den gamla versionen kan du komma åt den under en begränsad period genom att använda https://{tenantAlias}.old.vince.live",
        "logoAlt": "Vince-logotyp",
        "cards": {
            "feedback": {
                "title": "Ge oss feedback",
                "content": "Vi vill höra från dig!\nDin input formar framtiden för Vince. Hittade du en bugg? Har du en bra idé? Vill du berätta vad som fungerar, eller inte fungerar? Låt oss veta!",
                "buttonLabel": "Ge oss feedback"
            },
            "documentation": {
                "title": "Dokumentation",
                "content": "Allt du behöver – på ett ställe.\nOavsett om du är ny i Vince eller en erfaren användare, finns vår dokumentation här för att hjälpa dig. Bläddra bland guider, funktioner, inställningstips och mer.\n\nUtforska kunskapsbasen.",
                "buttonLabel": "Dokumentation"
            },
            "releaseNotes": {
                "title": "Versionsanteckningar",
                "content": "Håll dig uppdaterad om de senaste funktionerna, förbättringarna och buggfixarna. Vi håller våra versionsanteckningar enkla och tydliga – så du kan lägga mindre tid på att läsa och mer på att bygga.\nVi släpper regelbundet nya funktioner, förbättringar och fixar.\n\nKolla in hela ändringsloggen.",
                "buttonLabel": "Visa versionsanteckningar"
            },
            "news": {
                "title": "Nyheter från Vince",
                "content": "Vad händer hos Vince?\nHåll dig uppdaterad med produktnyheter, inblick bakom kulisserna och tips från vårt team. Vi bygger öppet – och du är inbjuden.\n\nSe de senaste höjdpunkterna.",
                "buttonLabel": "Besök Vince"
            }
        }
    },
    "menus": {
        "administration": "Administration",
        "home": "Hem",
        "info": "Info",
        "apps": "Applikationer",
        "settings": "Inställningar",
        "accessManagement": "Åtkomsthantering",
        "reports": "Rapporter",
		"aiSettings": "AI-hantering",
		"workflowSettings": "Arbetsflödesinställningar",
		"workflowManagement": "Arbetsflödeshantering",
		"external": "Hjälp och resurser",
		"integrations": "Integrationer",
        "subMenus": {
            "users": "Användare",
			"roles": "Roller",
			"apiClients": "API-klienter",
            "tenants": "Hyresgäster",
            "accessManagement": "Åtkomsthantering",
            "auditLog": "Revisionslogg",
            "companyManagement": "Företagshantering",
            "connections": "Anslutningar",
            "documentation": "Dokumentation",
            "environments": "Miljöer",
            "groups": "Grupper",
            "latestUpdates": "Senaste uppdateringar",
            "logOut": "Logga ut",
            "schedules": "Scheman",
            "support": "Support",
            "tableManagement": "Tabellhantering",
            "userProfile": "Min profil",
            "variables": "Variabler",
            "webhooks": "Webhooks",
            "workflowStatistics": "Arbetsflödesstatistik",
            "workflowMonitoring": "Arbetsflödesövervakning",
            "addConnection": "Lägg till anslutning",
            "editConnection": "Redigera anslutning",
			"newConnection": "Ny anslutning",
			"manageEnvironments": "Hantera miljöer",
            "apps": {
                "clickAndCollect": "Klicka och hämta",
                "campaign": "Kampanj",
                "impexHelper": "Impex-assistent",
                "mdbreadHelper": "MDBread-assistent",
                "miTest": "MI-test",
                "m3PrintoutConfig": "M3-utskriftsinställning",
                "vincePricer": "Vince-prissättare",
                "cugexHelper": "CUGEX-assistent",
                "lantmannenMaskin": "Lantmännen Maskin",
                "spykarChannelPlan": "Spykar kanalplan",
                "eshopbox": "Eshopbox",
                "scannerPickPack": "Skanner plock och pack",
                "pickPack": "Plock och pack",
                "contractManagement": "Avtalshantering"
            }
        },
        "workflows": "Arbetsflöden"
    },
    "profile": {
        "dateFormat": "Datumformat",
        "defaultDashboard": "Standardinstrumentpanel",
        "languagePreference": "Språkpreferens",
        "messages": {
            "error": "Kunde inte spara inställningar!",
            "success": "Inställningar sparades framgångsrikt!",
            "nameUpdatedSuccess": "Användarnamn uppdaterat framgångsrikt!"
        },
        "numberPerPage": "Antal rader i tabeller",
        "preferences": "Inställningar",
        "timeFormat": "Tidsformat",
        "userProfile": "Profilinställningar",
        "cookieConsent": {
            "title": "Cookie samtycke",
            "necessary": "Nödvändiga",
            "statistics": "Statistik",
            "description1": "Vissa av våra cookies är nödvändiga för att applikationen ska fungera och kan inte stängas av i våra system. De ställs vanligtvis in som svar på åtgärder som du gör, såsom att logga in, fylla i formulär eller ställa in dina sekretessinställningar.",
            "description2": "För att skapa lösningar för en applikation som är så användarvänlig som möjligt använder vi analysverktyget Posthog. Med hjälp av Posthog kan vi samla in data och analysera hur Vince-appar och tjänster används.",
            "infoTitle": "Vilken information lagras?",
            "description3": "Posthog tar emot allmän webb- och appstatistik. Ingen av detta kan användas för att identifiera användarna. Vince använder endast cookies för analytiska ändamål för att utveckla våra produkter för att bättre tillgodose våra användares behov, och inte för marknadsföringsändamål."
        },
        "privacyPolicy": {
            "title": "Integritetspolicy",
            "customerPortal": "Kundportal",
            "sections": [
                {
                "title": "1. Om oss",
                "content": "Denna integritetspolicy gäller Vince Live-plattformen (\"Vince Live\") och VXL Live Excel-tillägget (\"Tillägget\") för Microsoft 365 (tillsammans \"Tjänsten\").\nTjänsten drivs av Vince AS (org.nr. 896 890 042), ett företag registrerat i Norge med huvudkontor på Riddervolds gate 4, 0256 Oslo, Norge.\nVår webbplats är {website}.\nVi är personuppgiftsansvariga för kontorelaterade och tjänsterelaterade personuppgifter samt personuppgiftsbiträde för personuppgifter som kundorganisationer behandlar genom arbetsflöden på vår plattform.\nFör frågor eller förfrågningar om integritet kan du kontakta oss via vår {customerPortal} eller via e-post på {email}. Om tillämpligt kan du även kontakta vårt dataskyddsombud (DPO) via samma portal."
                },
                {
                "title": "2. Roller vid behandling",
                "content": "När vi tillhandahåller tjänsterna är vi personuppgiftsansvariga för kontodata, autentiseringsdata, loggar och analysdata.\nFör arbetsflödesdata är vi personuppgiftsbiträde och behandlar personuppgifter endast enligt instruktioner från kundorganisationerna, som ansvarar för information och laglig grund.\nBehandling av personuppgifter för kundorganisationers räkning regleras av våra Allmänna villkor och Personuppgiftsbiträdesavtal (DPA). Denna integritetspolicy gäller endast behandling där vi är personuppgiftsansvariga."
                },
                {
                "title": "3. Kategorier av personuppgifter vi behandlar (som personuppgiftsansvariga)",
                "content": "Vi behandlar följande kategorier av personuppgifter:",
                "items": [
                    "Kontodata: namn, e-postadress, organisationstillhörighet och roll",
                    "Autentiseringsdata: autentiseringsuppgifter, token och MFA-metoder",
                    "Identitetsdata från Microsoft Entra ID: unika identifierare och profiluppgifter som tas emot när du loggar in med ditt Microsoft arbets- eller skolkonto",
                    "Tekniska data: IP-adress, enhets- eller webbläsarinformation och sessionsidentifierare",
                    "Tjänsteloggar: systemloggar, felloggar samt gransknings-/aktivitetsloggar (även synliga för kundadministratörer)",
                    "Kommunikationsdata: kontaktuppgifter som används för operativa meddelanden",
                    "Analysdata (valfritt): användningsstatistik och felrapporter"
                ],
                "footer": "Faktureringsuppgifter hanteras separat enligt avtal och inte via plattformen.\nVi säljer eller hyr inte ut personuppgifter. De delas endast med personuppgiftsbiträden som beskrivs i denna policy eller när lagen kräver det."
                },
                {
                "title": "4. Syften och rättslig grund (som personuppgiftsansvariga)",
                "content": "Vi behandlar personuppgifter endast när det finns en rättslig grund enligt GDPR:",
                "items": [
                    "Fullgörande av avtal - hantering av användarkonton, autentisering av användare, drift av Tjänsterna och nödvändiga aktivitetsloggar",
                    "Berättigade intressen - övervakning av tjänster, operativa meddelanden och säkerhet",
                    "Samtycke - analys (valfritt; för analys av tjänstens prestanda och användbarhet, exklusive Kunddata)",
                    "Rättsliga skyldigheter - efterlevnad av lagstadgade krav"
                ]
                },
                {
                "title": "5. Arbetsflödesdata (rollen som personuppgiftsbiträde)",
                "content": "Kundorganisationer kan konfigurera arbetsflöden som innehåller personuppgifter. I dessa fall är kunden personuppgiftsansvarig och vi agerar endast som personuppgiftsbiträde. Vi behandlar arbetsflödesdata endast i den utsträckning som krävs för att tillhandahålla, säkra eller stödja tjänsterna."
                },
                {
                "title": "6. Personuppgiftsbiträden",
                "content": "Vi använder GDPR-kompatibla personuppgiftsbiträden, samtliga placerade inom EU/EES:",
                "items": [
                    "Amazon Web Services (AWS) - hosting och infrastruktur",
                    "Twilio / SendGrid - SMS- och e-postleverans",
                    "PostHog - analys (valfritt)",
                    "Sentry - felspårning"
                ]
                },
                {
                "title": "7. Registrerades rättigheter (som personuppgiftsansvariga)",
                "content": "Du har de rättigheter som följer av artiklarna 15-22 i GDPR, inklusive rätt till tillgång, rättelse, radering, begränsning, dataportabilitet, invändning och återkallelse av samtycke.\nDu har även rätt att lämna in klagomål till Datatilsynet enligt artikel 77 i GDPR. Information om hur du kontaktar Datatilsynet finns på {datatilsynet}.\nSjälvbetjäningsverktyg finns tillgängliga i plattformen, eller så kan du skicka en begäran via vår {customerPortal} eller via e-post till {email}. För arbetsflödesdata där vi agerar som personuppgiftsbiträde ska förfrågningar riktas till den berörda kundorganisationen."
                },
                {
                "title": "8. Lagring och radering",
                "content": "Personuppgifter sparas endast så länge som det är nödvändigt för att tillhandahålla tjänsten. Loggar och aktivitetsdata sparas i upp till 90 dagar. Efter att ett konto har avslutats raderas personuppgifterna inom 90 dagar, om inte längre lagring krävs enligt lag."
                },
                {
                "title": "9. Säkerhet",
                "content": "Vi tillämpar tekniska och organisatoriska säkerhetsåtgärder såsom kryptering av data under lagring och överföring, strikta åtkomstkontroller samt säker hosting inom EU/EES."
                },
                {
                "title": "10. Internationella överföringar",
                "content": "All hosting och personuppgiftsbehandling sker inom EU/EES. Inga internationella överföringar av personuppgifter sker."
                },
                {
                "title": "11. Ändringar",
                "content": "Vi kan uppdatera denna policy från tid till annan. Viktiga ändringar kommer att meddelas via plattformen eller via e-post."
                },
                {
                "title": "12. VXL Live Excel-tillägget",
                "content": "Detta avsnitt beskriver hur personuppgifter behandlas när du använder VXL Live Excel-tillägget för Microsoft 365 (\"Tillägget\").",
                "items": [
                    "Tillägget har endast behörighet att läsa och skriva i den aktuella arbetsboken. Det har inte åtkomst till andra filer, e-postlådor eller tjänster.",
                    "Data i arbetsboken som skickas till Vince Live som en del av ett arbetsflöde (vilket kan inkludera personuppgifter) behandlas som Arbetsflödesdata enligt avsnitt 5.",
                    "Tillägget använder inte arbetsbokens innehåll för reklam eller profilering och säljer eller hyr inte ut personuppgifter."
                ]
                },
                {
                "title": "13. Kontakt",
                "content": "Vince AS\nOrg.nr. 896 890 042\nRiddervolds gate 4, 0256 Oslo, Norge\n{website}\n{customerPortal}\nSenast uppdaterad: November 2025"
                }
            ]
        },
        "tableAndDataFormatting": "Tabell och dataformatering",
        "department": "Avdelning",
        "aiHelperLevel": "Kunskapsnivå om Vince Platform",
        "aiHelperLevels": {
            "beginner": "Precis börjat - Nybörjare",
            "intermediate": "Viss erfarenhet - Medel",
            "advanced": "Ganska säker - Avancerad",
            "expert": "Använder detta hela tiden - Expert"
        }
    },
    "security": {
        "accessManagement": "Åtkomsthantering",
        "forbidden": "Förbjuden",
        "youDontHavePermission": "Du har inte behörighet att komma åt den här resursen. Kontakta din klientadministratör angående dina behörigheter.",
        "apiClients": {
            "activateApiClients": "Vill du aktivera API-klienten?",
            "active": "Aktiv",
            "addApiClients": "Lägg till API-klienter",
            "apiClient": "API-klient",
            "apiClientName": "API-klientnamn",
            "createApiClients": "Skapa API-klienter",
            "deactivateApiClients": "Vill du inaktivera API-klienten?",
            "description": "Beskrivning",
            "loadingApiClients": "Laddar API-klienter...",
            "name": "Namn",
            "updatingApiClientsRoles": "Uppdaterar API-klientroller..."
        },
        "roles": {
            "bulkAssign": {
                "showSelectedOnly": "Visa endast valda",
                "hiddenByPermission": "{count} användare är dolda eftersom du inte har behörighet att redigera dem.",
                "button": "Tilldela användare",
                "title": "Tilldela användare till {roleName}",
                "subtitle": "{count} användare har den här rollen just nu.",

                "modes": {
                    "add": "Lägg till den här rollen",
                    "remove": "Ta bort den här rollen",
                    "replace": "Ersätt alla roller med den här"
                },
                "replaceWarning": "{count} valda användare förlorar sina övriga roller.",
                "replaceConfirmHeader": "Ersätta alla roller?",
                "replaceConfirmMessage": "{count} valda användare förlorar alla andra roller de har. Detta kan inte ångras.",
                "searchPlaceholder": "Sök användare…",
                "selectShown": "Välj synliga",
                "selectMembers": "Välj med rollen",
                "selectedCount": "{count} användare valda",
                "clearSelection": "Rensa urval",
                "alreadyAssigned": "Har rollen",
                "noUsers": "Inga användare hittades",
                "apply": {
                    "add": "Tilldela till {count} användare",
                    "remove": "Ta bort från {count} användare",
                    "replace": "Ersätt roller för {count} användare"
                },
                "applying": "Uppdaterar {done}/{total}…",
                "success": "{count} användare uppdaterade",
                "partialFailure": "{updated} uppdaterade, {failed} misslyckades — misslyckade användare förblir valda för nytt försök"
            },
            "header": "Roller",
            "addRole": "Lägg till roll",
            "roleName": "Rollnamn",
            "placeholder": "Välj roller",
            "newRole": "Ny roll",
            "inactive": "Inaktiv",
            "active": "Aktiv",
            "numberOfUsers": "Antal användare",
            "numberOfPermissions": "Antal behörigheter",
            "externalId": "Externt ID",
            "externalIdPlaceholder": "IdP-grupp-ID (t.ex. Microsoft Entra-gruppobjekt-ID)",
            "externalIdHint": "Koppla den här rollen till en grupp hos identitetsleverantören för SCIM-provisionering.",
            "table": {
                "app": "App",
                "resource": "Resurs",
                "resourceName": "Resursnamn",
                "addPermissions": "Lägg till behörigheter",
                "selectApp": "Välj app",
                "selectResource": "Välj resurs",
                "selectResourceName": "Välj resursnamn",
                "selectPermission": "Välj behörighet",
                "permission": "Behörighet",
                "resourceNameNotAvailable": "Namnet på denna resurs var inte tillgängligt."
            },
            "messages": {
                "nameRequired": "Rollnamn krävs.",
                "descriptionRequired": "Beskrivning krävs.",
                "appRequired": "Applikation krävs.",
                "resourceRequired": "Resurs krävs.",
                "resourceNameRequired": "Resursnamn krävs.",
                "actionRequired": "Åtgärd krävs.",
                "success": "Rollen har sparats.",
                "deleteRoleConfirmation": "Är du säker på att du vill ta bort rollen {roleName}?",
                "deleteRoleSuccess": "Rollen har tagits bort.",
                "activateSuccess": "Rollen har aktiverats!",
                "deactivateSuccess": "Rollen har inaktiverats!"
            }
        },
        "users": {
            "addUser": "Lägg till användare",
            "lastActive": "Senast aktiv",
            "manageUser": "Hantera användare",
            "deactivateUser": "Inaktivera användare",
            "deactivateUserConfirm": "Vill du inaktivera den här användaren?",
			"deactivateSuccessMessage": "Användaren har avaktiverats framgångsrikt",
			"activateUser": "Aktivera användare",
			"activateUserConfirm": "Vill du aktivera denna användare?",
			"activateSuccessMessage": "Användaren har aktiverats framgångsrikt",
			"resendInvite": "Skicka inbjudan igen",
			"resendInviteSuccessMessage": "Inbjudan har skickats till användaren",
            "userType": "Användartyp",
            "userTypes": {
                "PLATFORM_USER": "Plattformsanvändare",
                "EXTERNAL_USER": "Extern användare"
            },
            "assignRolesToUser": "Lägg till den här användaren i roller",
            "assignTagsToUser": "Tilldela taggar till den här användaren",
            "permissions": {
                "VINCE_LIVE_ADMIN": "Live Admin",
                "VINCE_LIVE_USER": "Live Användare",
                "TENANT_ADMIN": "Admin",
                "TENANT_USER": "Användare"
            },
            "activeUsers": "{used}/{total} aktiva användare på din hyresplan.",
            "abovePlan": "Du överstiger din plan, kostnader kommer att läggas till per användare.",
            "upgradePlanLink": "Uppgradera din plan"
        }
    },
    "signIn": {
        "backToSignIn": "Tillbaka till inloggning",
        "forgotPassword": "Glömt lösenord?",
        "forgotPasswordInstruction": "Du kommer att få ett e-postmeddelande och en kod för att återställa ditt lösenord.",
        "invalidPassword": "! Fel lösenord",
        "login": "Logga in",
        "loginMicrosoft": "Logga in med Microsoft",
        "loginOkta": "Logga in med Okta",
        "preparingVince": "Förbereder din Vince-upplevelse...",
        "resetPassword": "Återställ lösenord",
        "signinTo": "Logga in på {tenant}",
        "userNotFound": "! Oops, e-post hittades inte. Vänligen ange en registrerad e-postadress eller kontakta support",
        "confirmationCodeRequired": "Bekräftelsekod krävs",
		"passwordCriteriaMismatch": "! Lösenordet matchar inte kriterierna",
		"invalidConfirmationCode": "Ogiltig verifieringskod har angetts, försök igen.",
		"attemptLimitExceeded": "Antalet försök har överskridits, försök senare.",
		"confirmationCode": "Bekräftelsekod",
		"confirmationCodeInstruction": "Bekräftelsekoden har skickats till din e-postadress.",
		"newPassword": "Nytt lösenord",
		"newPasswordInstruction": "* Lösenordet måste vara minst 8 tecken långt och innehålla minst en stor bokstav, en liten bokstav och en siffra",
        "invalidParameter": "Fel vid återställning av lösenord, kontakta supporten för ytterligare hjälp",
        "enterValidEmail": "Ange en giltig e-postadress.",
        "userDisabled": "Användaren är inaktiverad, vänligen kontakta supporten",
        "selectSsoProvider": "Välj SSO-leverantör",
        "processingSso": "Bearbetar SSO-inloggning....",
        "ssoAuthFailed": "Autentiseringen misslyckades. Försök igen.",
        "externalAuthRedirecting": "Omdirigerar...",
        "externalAuthCompleted": "Autentiseringen är klar. Du kan stänga det här fönstret.",
        "externalAuthFailed": "Autentiseringen misslyckades. Du kan stänga det här fönstret och försöka igen.",
        "verifyIdentity": "Verifiera din identitet",
        "smsMfaInstruction": "En verifieringskod har skickats till din telefon. Ange den nedan för att fortsätta.",
        "smsCode": "Verifieringskod",
        "verify": "Verifiera",
        "smsCodeRequired": "Verifieringskod krävs",
        "invalidSmsCode": "Ogiltig verifieringskod, försök igen."
    },
    "tables": {
        "chooseExcelFile": "Välj fil",
        "columns": "Kolumner",
        "copy": "Kopiera tabell",
        "copyPrefix": "Kopia av ",
        "createdBy": "Skapad av",
        "createTable": "Skapa tabell",
        "emptyFilteredText": "Det finns inga poster som matchar din förfrågan.",
        "noEntitiesMessage": "Inga enheter i denna hyresgästarbetsyta.",
        "delete": "Ta bort tabell",
        "deletingInProgress": "Borttagning pågår...",
        "deleteConfirmation": "Är du säker på att du vill ta bort tabell {tableName}? \nBorttagningsprocessen kan ta upp till 6 timmar. \nUnder denna tid kommer tabellen att förbli i statusen \n\"Borttagning pågår...\"",
        "deleteData": "Ta bort innehåll",
        "deleteItem": "Ta bort tabell",
        "deleteTableSuccess": "Tabell raderad framgångsrikt",
        "dragExcelFiles": "Dra och släpp Excel-filer hit för att ladda upp.",
        "edit": "Redigera tabell",
        "validateConnection": "Validera anslutning",
		"importAPIs": "Importera API:er",
		"issueMTLSCert": "Utfärda MTLS-certifikat",
		"editConnection": "Redigera",
		"deleteConnection": "Slett",
        "form": {
            "addColumnButton": "Lägg till kolumn",
            "allowOtherColumns": "Tillåt andra kolumner vid datauppladdning",
            "allowOtherColumnsHelp": "Kolumner som inte definieras här behålls vid datauppladdning",
            "enforceSchemaHelp": "Avvisa rader som inte matchar kolumntyperna",
            "enforceSchema": "Tvinga datatyper",
            "advancedConfiguration": "Avancerad konfiguration",
            "required": "Obligatorisk",
            "inferenceEmpty": "Ingen data i den här kolumnen, välj en typ",
            "inferenceNumericText": "Sparad som text i Excel, menade du ett tal?",
            "inferenceMixedValues": "Vissa värden stämmer inte, kontrollera data eller typ",
            "inferenceBinaryInteger": "Endast 0 och 1, ska det vara ja/nej?",
            "inferenceVerify": "Vänligen verifiera typen",
            "inferenceProbablyWrong": "Den här typen är troligen fel, välj en",
            "columnAliasNameField": "Aliasnamn",
            "columnNameField": "Kolumnnamn",
            "dataTypeField": "Datatyp",
            "linkField": "Länk",
            "linkTextField": "Länktext",
            "primaryKeyField": "Primärnyckel",
            "type": "Typ *",
            "key": "Primärnyckel",
            "validations": {
                "duplicateColumnNamesError": "Dubblettkolumnnamn hittades: {duplicates}.",
                "reservedColumnNameError": "Detta kolumnnamn är reserverat",
                "emptyColumnNameError": "Kolumnnamn kan inte vara tomt."
            }
        },
        "modifiedBy": "Ändrad av",
        "new": "Skapa ny tabell",
        "rows": "Rader",
        "showColumnConfig": "Kolumninformation",
        "showData": "Visa data",
        "tableConfig": "Tabellkonfiguration",
        "title": "Tabellhantering",
        "tableName": "Tabellnamn",
        "tableNameSlugified": "Tabellnamnet sätts till {name}",
        "tableNameTaken": "Det finns redan en tabell med namnet {name}. Välj ett annat namn.",
        "truncateConfirmation": "Är du säker på att du vill ta bort alla rader i tabell {tableName}?",
        "truncateItem": "Töm tabell",
        "truncateTableSuccess": "Tabelldata raderades framgångsrikt",
        "updateType": "Uppdateringstyp",
        "updateTypes": {
            "APPEND": "Lägg till",
            "REPLACE": "Ersätt",
            "UPSERT": "Uppdatera eller lägg till"
        },
        "uploadData": "Ladda upp data",
        "importColumns": "Importera kolumner",
        "importBack": "Tillbaka",
        "importHeading": "Importera kolumner från en fil",
        "importSubheading": "Kolumner, typer och primärnyckel föreslås utifrån filen. Du kan granska dem innan tabellen skapas.",
        "importReadSettings": "Läsinställningar",
        "importReadSettingsHint": "Radnummer som visas i Excel",
        "choiceManualTitle": "Definiera kolumner manuellt",
        "choiceManualDescription": "Lägg till kolumner och välj typerna själv",
        "choiceImportTitle": "Importera från Excel eller CSV",
        "choiceImportDescription": "Välj en fil och få föreslagna kolumner, typer och nyckel",
        "importSummary": "Importerade {count} kolumner från {fileName} ({sheet})",
        "importSummaryNoSheet": "Importerade {count} kolumner från {fileName}",
        "importSuccessTitle": "Kolumner importerade",
        "chooseAnotherFile": "Välj en annan fil",
        "uploadFailed": "Data kunde inte laddas upp",
        "uploadFailedGeneric": "Data kunde inte laddas upp. Försök igen.",
        "uploadErrorAt": "Rad {row}, kolumn {column}: {message}",
        "uploadErrorAtRow": "Rad {row}: {message}",
        "uploadErrorMissingValue": "värde saknas",
        "uploadErrorNoHeader": "Kolumn {column} saknar rubrik. Lägg till en rubrik eller ta bort kolumnen.",
        "uploadErrorReservedHeader": "Kolumn {column}: rubriken ”{header}” får inte börja med __.",
        "uploadErrorDuplicateKey": "Rad {rows} har samma {keys}. Primärnyckeln måste vara unik.",
        "uploadErrorDuplicateKeyValue": "Rad {rows} har samma {keys} ({values}). Primärnyckeln måste vara unik.",
        "backToStartHeader": "Ignorera kolumner?",
        "backToStartConfirmation": "Om du går tillbaka tas kolumnerna du har lagt till eller importerat bort.",
        "importNeedReview": "{count} behöver granskas",
        "importFileError": "Det gick inte att läsa den valda filen",
        "importSheet": "Blad",
        "importHeaderRow": "Rubrikrad",
        "importDataRow": "Data börjar på rad",
        "importRowAuto": "Automatiskt",
        "importNoColumns": "Inga kolumner hittades i filen",
        "date": "Datum",
        "dateTypes": "Datumtyper",
        "deleteRowMessage": "Är du säker på att du vill ta bort de markerade raderna?",
		"deleteRowSuccess": "Markerade rader raderade. Det kan ta en stund innan ändringarna visas.",
		"deleteRowButtonLabel": "Ta bort ({selectedRows} rader)",
        "saveSuccess": "Tabellkonfigurationen har sparats."
    },
    "tags": {
        "addTag": "Lägg till tagg",
        "duplicateKey": "En tagg med denna nyckel finns redan",
        "editTag": "Redigera tagg",
        "createTag": "Skapa tagg",
        "placeholder": "Taggar är nyckel-värdepar som användaren kan koppla till entiteter för att filtrera data och kontrollera åtkomst i Vince Platform",
		"noTagsApplied": "Inga taggar tillämpade för den här användaren",
        "confirmRemoveRole": "Är du säker på att du vill ta bort rollen '{roleName}' från den här användaren?",
        "confirmRemoveTag": "Är du säker på att du vill ta bort taggen?",
		"tagName": "Taggnamn",
		"tagValue": "Värde/Nyckel",
        "nameOfTag": "Namn på tagg",
		"valueKey": "Värdenyckel"
    },
    "users": {
        "bulkTag": {
            "button": "Ange tagg för användare",
            "title": "Ange tagg för användare",
            "subtitle": "Välj en tagg och ange sedan ett värde för varje användare.",
            "tagName": "Taggnamn",
            "tagNamePlaceholder": "Välj en befintlig tagg eller ange en ny",
            "hint": "Välj användarna som ska taggas och ge var och en ett värde. Övriga befintliga taggar behålls.",
            "hiddenByPermission": "{count} användare är dolda eftersom du inte har behörighet att redigera dem.",
            "searchPlaceholder": "Sök användare…",
            "fillPlaceholder": "Värde för synliga användare…",
            "fill": "Använd",
            "selectAll": "Välj alla",
            "selectedCount": "{count} användare valda",
            "missingValue": "{count} utan värde",
            "unchanged": "{count} oförändrade",
            "showSelectedOnly": "Visa valda",
            "clearValues": "Rensa värden",
            "valuePlaceholder": "värde",
            "noUsers": "Inga användare hittades",
            "apply": "Använd på {count} användare",
            "applying": "Uppdaterar {done}/{total}…",
            "success": "{count} användare uppdaterade",
            "partialFailure": "{updated} uppdaterade, {failed} misslyckades — misslyckade rader behålls för nytt försök"
        },
        "addRoles": "Lägg till roller",
        "addUser": "Lägg till användare",
        "newUser": "Ny användare",
        "edit": "Redigera",
        "personalInfo": "Personlig information",
        "saveSuccess": "Användare sparad",
        "saveError": "Fel vid sparande av användare",
        "userNotFound": "Användare hittades inte",
        "loadError": "Fel vid inläsning av användardata",
        "selectRole": "Välj en roll",
        "userFields": {
            "lastActive": "Senast aktiv",
            "m3userId": "M3-användar-ID",
            "identityProvider": "Inloggningsmetod"
        },
        "identityProviders": {
            "SSO": "SSO",
            "MANUAL": "Manuell"
        },
        "assignRolesToUser": "Lägg till den här användaren i roller",
        "assignTagsToUser": "Tilldela taggar till den här användaren",
        "validation": {
            "keyRequired": "Nyckel krävs",
            "duplicateTagKey": "Tagg-nyckel \"{value}\" finns redan",
            "valueEmpty": "Värdet kan inte vara tomt",
            "valueRequired": "Minst ett värde krävs",
            "singleValueAllowed": "Endast ett värde tillåts",
            "firstNameRequired": "Förnamn krävs",
            "firstNameMinLength": "Förnamn måste vara minst 2 tecken",
            "firstNameMaxLength": "Förnamn får inte överstiga 50 tecken",
            "lastNameRequired": "Efternamn krävs",
            "lastNameMinLength": "Efternamn måste vara minst 2 tecken",
            "emailRequired": "E-post krävs",
            "emailInvalid": "Ange en giltig e-postadress",
            "emailInUse": "Den här e-postadressen används redan",
            "permissionRequired": "Behörighet krävs"
        }
    },
    "roles": {
        "addRole": "Lägg till roll",
		"createRole": "Skapa roll",
        "placeholder": "Roller är något som ger behörighet att visa eller redigera instrumentpaneler, arbetsflöden eller tabeller",
		"noRolesApplied": "Inga roller tillämpade för den här användaren"
    },
    "apiClients": {
        "apiClientName": "API-klientnamn",
        "description": "Beskrivning",
        "active": "Aktiv",
        "action":"Åtgärd",
        "addApiClient": "Lägg till API-klient",
        "messages": {
            "deleteAPIClientConfirmation": "Är du säker på att du vill ta bort API-klienten '{apiClientName}'?",
            "deleteAPIClientSuccess": "API-klienten har tagits bort.",
            "deactivateAPIClientConfirmation": "Vill du inaktivera API-klienten '{apiClientName}'?",
            "apiClientNameRequired": "Klientnamn krävs",
            "success": "API-klienten har sparats!",
            "activateSuccess": "API-klienten har aktiverats!",
			"deactivateSuccess": "API-klienten har inaktiverats!",
			"apiClientNameInvalid": "Namnet får endast innehålla alfanumeriska tecken, mellanslag och följande: +=,.@-"
        },
        "name":"Namn",
        "label":"Etikett",
        "roles":"Roller",
        "clientId": "API-klient-ID",
        "clientSecret": "API-klienthemlighet",
        "newAPIClient": "Ny API-klient",
        "editAPIClient": "Redigera API-klient"
    },
    "webhooks": {
        "activateSuccess": "Webhook aktiverad!",
        "deactivateSuccess": "Webhook inaktiverad!",
        "description": "Beskrivning",
        "invalidWorkflow": "Ogiltigt arbetsflöde",
        "messages": {
            "copied": "Kopierad till urklipp",
            "copyError": "Misslyckades med att kopiera",
            "deleteWebhookConfirmation": "Är du säker på att du vill ta bort webhook {webhookName}?",
            "deleteWebhookSuccess": "Webhook borttagen!",
            "success": "Webhook sparad!",
            "webhookNameRequired": "Webhook-namn krävs",
            "workflowRequired": "Arbetsflöde krävs"
        },
        "newWebhook": "Ny Webhook",
        "title": "Webhooks",
        "webhookDetails": "Webhook-detaljer",
        "webhookId": "Webhook-ID",
        "webhookName": "Webhook-namn",
        "workflow": "Arbetsflöde",
        "username": "Användarnamn",
        "password": "Lösenord",
        "token": "Token"
    },
    "variables": {
        "addVariable": "Lägg till variabel",
        "editVariables": "Redigera variabel",
        "tooltip": "Variabler används för att lagra värden som kan användas i arbetsflöden.",
        "messages": {
            "success": "Variabeln har sparats!",
            "deleteVariableConfirmation": "Vill du ta bort variabeln {variableName}?",
            "varibaleNameRequired": "Variabelnamn krävs",
            "variableValueRequired": "Variabelvärde krävs",
            "deleteSuccess": "Variabeln har tagits bort!"
        },
        "name": "Namn",
        "secure": "Säker",
        "title": "Variabler",
        "value": "Värde",
        "newVariable": "Ny variabel",
        "unsecure": "Oskyddad"
    },
    "company": {
        "headers": {
          "settings": "Företagsinställningar",
          "identityProviders": "Identitetsleverantörer",
          "identityProvidersName": "Identitetsleverantörens namn",
          "enterpriseIntegrations": "Företagsintegrationer",
          "companyInformation": "Företagsinformation"
        },
        "tabs": {
            "information": "Information",
            "scim": "Scim",
            "singlesignon": "Single Sign-On"
        },
        "labels": {
          "identityProvider": "Identitetsleverantör",
          "scimUrl": "SCIM-URL",
          "token": "Token",
          "enforceSso": "Tvinga SSO",
          "identityProviderName": "Identitetsleverantörens namn",
          "issuerUrl": "Utfärdarens URL",
          "clientId": "Klient-ID",
          "clientSecret": "Klienthemlighet",
          "companyName": "Företagsnamn",
          "tenantId": "Hyresgäst-ID",
          "industry": "Bransch",
          "selectIndustry": "Välj bransch",
			"dedicatedIpAddresses": "Dedikerade IP-adresser",
			"dedicatedIpWhitelistInfo": "Vitlista dessa IP-adresser för att tillåta trafik från din dedikerade proxy"
        },
        "placeholders": {
          "selectIdentityProvider": "Välj identitetsleverantör",
          "scimUrl": "SCIM-URL",
          "token": "Token",
          "identityProviderName": "Identitetsleverantörens namn",
          "issuerUrl": "Utfärdarens URL",
          "clientId": "Klient-ID",
          "clientSecret": "Klienthemlighet"
        },
        "buttons": {
          "addIdentityProvider": "Lägg till identitetsleverantör",
          "regenerateToken": "Återskapa token"
        },
        "messages": {
          "identityProviderDeleted": "Identitetsleverantör borttagen.",
          "deleteConfirmation": "Är du säker på att du vill ta bort identitetsleverantören '{providerName}'?",
          "configuringIdentityProvider": "Identitetsleverantören konfigureras. Detta kan ta ett ögonblick.",
          "updatedIdentityProvider": "Identitetsleverantör uppdaterad.",
          "ssoUpdated": "SSO-inställningar uppdaterade.",
          "enforceSsoDisabledTooltip": "Lägg till en identitetsleverantör för att aktivera SSO-tvång.",
          "tokenGenerated": "SCIM-token genererad.",
          "copied": "Kopierat till urklipp.",
          "copyError": "Kunde inte kopiera till urklipp.",
          "industryUpdated": "Bransch uppdaterad.",
          "industryUpdateError": "Det gick inte att uppdatera bransch."
        },
        "validation": {
          "identityProviderRequired": "Identitetsleverantör krävs.",
          "issuerUrlRequired": "Utfärdarens URL krävs.",
          "clientIdRequired": "Klient-ID krävs.",
          "clientSecretRequired": "Klienthemlighet krävs."
        },
        "tooltips": {
            "tokenInfo": "Om du förlorar din token kan du inte återställa den. Du måste istället skapa en ny."
        }
      },
    "buttonType": {
        "PRIMARY": "Primär",
        "SECONDARY": "Sekundär",
        "OUTLINE_PRIMARY": "Primär med kontur",
        "OUTLINE_SECONDARY": "Sekundär med kontur",
        "OUTLINE_DANGER": "Fara med kontur",
        "LINK_PRIMARY": "Primär länk",
        "LINK_DANGER": "Farlänk"
    },
    "auditLogs": {
        "title": "Granskningsloggar",
        "selectEntity": "Välj entitet",
        "startDate": "Startdatum",
        "endDate": "Slutdatum",
        "apply": "Tillämpa",
        "reset": "Återställ",
        "entity": {
            "users": "Användare",
            "roles": "Roller",
            "workflows": "Arbetsflöden",
            "connections": "Anslutningar",
            "environments": "Miljöer",
            "application": "Applikation",
            "appVersion": "Appversion",
            "appResource": "Appresurs",
            "roleAssignment": "Rolltilldelning",
            "mcpServer": "MCP-server",
            "tenantPrompt": "Tenant-prompt"
        },
        "entityGroup": {
            "platform": "Plattform",
            "aiApps": "AI-appar"
        },
        "table": {
            "userName": "Användarnamn",
            "timeStamp": "Tidsstämpel",
            "entity": "Entitet",
            "entityName": "Namn",
            "action": "Åtgärd",
            "details": "Information"
        },
        "expansion": {
            "user": "Användare:",
            "dateModified": "Ändringsdatum:",
            "changed": "Ändrat:",
            "viewChanges": "Visa ändringar"
        }
    },
    "filters": {
        "tag": "Tagg: {tag}",
        "field": "Fält: {field}",
        "context": "Kontext: {context}",
        "relativeDates": {
            "0_DAY_START": "Början av idag",
            "1_DAY_START": "Början av imorgon",
            "-1_DAY_START": "Början av igår",
            "0_WEEK_START": "Början av denna vecka",
            "1_WEEK_START": "Början av nästa vecka",
            "-1_WEEK_START": "Början av förra veckan",
            "0_MONTH_START": "Början av denna månad",
            "1_MONTH_START": "Början av nästa månad",
            "-1_MONTH_START": "Början av förra månaden",
            "0_QUARTER_START": "Början av detta kvartal",
            "1_QUARTER_START": "Början av nästa kvartal",
            "-1_QUARTER_START": "Början av förra kvartalet",
            "0_YEAR_START": "Början av detta år",
            "1_YEAR_START": "Början av nästa år",
            "-1_YEAR_START": "Början av förra året"
        }
    }
}
